const INITIAL_QUESTION = `Please write at least a one-page statement on why you think your most distressing traumatic event occurred. You are not being asked to write specific details about this event. Write down what you have been thinking about the cause of this event.

Also, consider the effects this traumatic event has had on your beliefs about yourself, others, and the world in the following areas: safety, trust, power/control, esteem, and intimacy.`

const LATER_QUESTION = `Please write at least one page on what you think now about why this traumatic event(s) occurred.
Also, consider what you believe now about yourself, others, and the world in the following areas: safety, trust, power/control, esteem, and intimacy.`

export function createImpactStatementConfig() {
	return {
		title: "Impact Statement",
		wordingPresets: [{title: "Later Impact Statement", instructions: "Bring this statement with you to the next session.", fields: [{id: "laterStatement", type: "MULTILINE", title: LATER_QUESTION, isRequired: false}], reviewLabels: {status: "Later statement"}}],
		instructions: "Bring this statement with you to the next session. Also, please read over the handout I have given you on PTSD symptoms so that you understand the ideas we are talking about.",
		fields: [{id: "initialStatement", type: "MULTILINE", title: INITIAL_QUESTION, isRequired: false}],
		reviewLabels: {statement: "Client statement", themes: "Practitioner themes", highlights: "Highlighted passages", revisit: "Later revisit", history: "Earlier statements", status: "Baseline statement"},
		fixedPromptSequence: true,
		requireAnyTextAnswer: true,
		showPriorResults: true,
	}
}

export function createLaterImpactStatementConfig() {
	return {
		...createImpactStatementConfig(),
		title: "Later Impact Statement",
		instructions: "Bring this statement with you to the next session.",
		fields: [{id: "laterStatement", type: "MULTILINE", title: LATER_QUESTION, isRequired: false}],
		reviewLabels: {...createImpactStatementConfig().reviewLabels, status: "Later statement"},
	}
}

export function createImpactStatementDemoPayload() {
	return {
		form: createImpactStatementConfig(),
		answers: {initialStatement: "I keep thinking I should have seen the warning signs. Since then, trusting people has felt harder."},
		scoreResult: null,
	}
}

